import { render, staticRenderFns } from "./ValeEdit.vue?vue&type=template&id=512bfc08&scoped=true&"
import script from "./ValeEdit.vue?vue&type=script&lang=js&"
export * from "./ValeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ValeEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ValeEdit.vue?vue&type=style&index=1&id=512bfc08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512bfc08",
  null
  
)

export default component.exports